export * from './app-calendar.component';


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-calendar/index.ts